import React, { useCallback } from "react";
import { withRouter } from "react-router";
import {app} from "./firebaseconfig";
import Header1 from "./Header"
import Footer from "./Footer"
import ReCAPTCHA from "react-google-recaptcha";
import { Button, Form, FormGroup, Label, Input, FormText, Alert } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga"



function SignUp ({ history }){

  
   
  const handleSignUp = useCallback(async event => {
    ReactGA.initialize("UA-177281473-1", {siteSpeedSampleRate: 100})
    ReactGA.event({
      category:'SignUp',
      action:"SignUp"
    })
    event.preventDefault();
    const { email, password } = event.target.elements;
    console.log(email.value ,password.value)
    try {
      await app.auth().createUserWithEmailAndPassword(email.value, password.value);
      history.push("/Upload_Your_Documents");
    } catch (error) {
      alert(error);
    }
  }, [history]);
  


  return (
    <>
      <section id="cta2" className="container">
      <Header1></Header1>
      </section>
      <br></br>
      <br></br>
      <br></br>
      <section className="box special">
       <form onSubmit={handleSignUp}>
       
       <h2>Sign Up</h2><br/>
      
        <Input type="email" name="email" placeholder="Email" /><br/>

        <Input type="password" name="password" placeholder="Password" /><br/>
         
         
     <label>*By Signing up You Agree to the <a href="/termsofservice">Terms of Service</a> and <a href="/privacypolicy">Privacy Policy</a>.</label><br/><br/>

                
          
      <button type="submit" className="button primary"> Sign Up </button> 
      
      
        <br></br><br></br>
      
     
     </form>
     </section>
     <Footer></Footer>
     </>
  );
};

export default withRouter(SignUp);